import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { EmployeeDto, PaginatedResult } from '@coin/shared/core/util-models';
import { MatDialogRef } from '@angular/material/dialog';
import { StorageService } from '@coin/shared/core/data-access';
import { StorageKey } from '@coin/shared/core/util-enums';
import { GetEmulationPeopleService } from '@coin/shared/auth/data-access';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'coin-siemens-energy-select-emulate-person',
  templateUrl: './select-emulate-person.component.html',
  styleUrls: ['./select-emulate-person.component.scss'],
  standalone: false
})
export class SelectEmulatePersonComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<SelectEmulatePersonComponent>>(MatDialogRef);
  private getEmulateableUsers = inject(GetEmulationPeopleService);
  private storageService = inject(StorageService);
  private destroyRef = inject(DestroyRef);

  public emulateablePersons: PaginatedResult<EmployeeDto> = { content: [], total: 0 };
  public loading = false;

  public user = {
    gid: '',
    name: {
      firstname: '',
      lastname: ''
    }
  };
  public recentlyEmulated: EmployeeDto[] = [];

  public ngOnInit(): void {
    this.loadRecentlyEmulated();
  }

  private async loadRecentlyEmulated(): Promise<void> {
    this.recentlyEmulated = (await this.storageService.getAsync(StorageKey.RECENTLY_EMULATED)) ?? [];
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public proceed(userToBeEmulated: EmployeeDto): void {
    this.storageService.setAsync(
      StorageKey.RECENTLY_EMULATED,
      [userToBeEmulated, ...this.recentlyEmulated.filter(employee => employee.id !== userToBeEmulated.id)].slice(0, 3)
    );
    this.dialogRef.close(userToBeEmulated);
  }

  public search(): void {
    this.loading = true;
    this.getEmulateableUsers
      .getEmulatePeople(this.user)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newEmulateableUsers => {
        this.emulateablePersons = newEmulateableUsers;
        this.loading = false;
      });
  }
}
